import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '~/modules/query/base';
import { NOTIFICATION_API_URL } from '~/lib/environment';

/** service-notification's own tag registry; it shares the Toolbox axios transport and sysbay's `{result}` envelope. */
export const notificationApi = createApi({
  reducerPath: 'notificationApi',
  baseQuery: axiosBaseQuery({ baseUrl: NOTIFICATION_API_URL }),
  tagTypes: ['NotificationTemplate', 'NotificationProviderKey'],
  endpoints: () => ({}),
});
